import { DataOperationUtil } from '../../../service';
import { MultiScaleOption } from './multi-scale-option';
import { MultiScaleOptionField } from './multi-scale-option-field';

/**
 * ä½¿ç¨ä¸¾ä¾
 let placeholder = 'æªéæ©é¡¹ç®åç±»';
 let choiceIds = (option.link ? option.link.split('-') : []).map(item => +item);
 let field = new MultiScaleOptionField('parentIdx', 'idx', 'name');
 new MultiScale(placeholder, choiceIds).setOptionsByFlat(flatOptions, field).initScales();
 */
export class MultiScale {
  // æ ¼å¼ä¸º [[MultiScaleOption],[MultiScaleOption],[MultiScaleOption]]
  scales: MultiScaleOption[][] = [];
  options: MultiScaleOption[] = [];
  choiceOption: MultiScaleOption = new MultiScaleOption();

  constructor(public placeholder?: string,
              public choiceIds?: number[]) {
  }

  hasChildren(parentOption: MultiScaleOption): boolean {
    return this.getChildren(parentOption).length > 0;
  }

  setNextScale(option: MultiScaleOption, scaleIndex: number): MultiScale {
    this.scales = this.scales.filter((scale, index) => index <= scaleIndex);
    let nextScale = this.getChildren(option);
    nextScale.forEach(optionItem => {
      optionItem.choice = false;
    });
    if (nextScale.length > 0) {
      this.scales.push(nextScale);
    }
    return this;
  }

  initScales(): MultiScale {
    if (this.scales.length === 0) {
      this.scales.push(this.getChildren(new MultiScaleOption(-1, -1)));
    }
    return this;
  }

  setOptionsByFlat(flatData: any[], field: MultiScaleOptionField): MultiScale {
    flatData = flatData || [];
    this.options = [];
    flatData.forEach(item => {
      let option = new MultiScaleOption(item[field.parentIdFiled], item[field.idField], item[field.nameField]);
      if (DataOperationUtil.arrayIncludes(this.choiceIds, item[field.idField])) {
        option.choice = true;
      }
      if (this.getChoiceOptionId(this.choiceIds) === item[field.idField]) {
        this.choiceOption = option;
      }
      this.options.push(option);
    });
    if (this.choiceOption.isEmpty()) {
      this.choiceOption.name = this.placeholder;
    } else {
      this.scales = [];
      this.setScaleChoiceStatus(this.choiceOption);
    }
    this.setOptionLinkName(this.choiceOption);
    return this;
  }

  changeOption(option: MultiScaleOption, scaleIndex: number) {
    if (option.choice) {
      this.choiceOption = option;
      this.setOptionLinkName(this.choiceOption);
      return;
    }
    this.clearChoice(scaleIndex);
    option.choice = true;
    this.choiceOption = option;
    this.setOptionLinkName(this.choiceOption);
  }

  scalesIsEmpty() {
    if (this.scales && this.scales.length > 0) {
      return !this.scales.some(scale => scale && scale.length > 0);
    }
    return true;
  }

  private getChildren(parentOption: MultiScaleOption): MultiScaleOption[] {
    return this.options.filter(option => option.parentId === parentOption.id);
  }

  private clearChoice(scaleIndex: number) {
    this.scales[scaleIndex].forEach(item => item.choice = false);
  }

  private getChoiceOptionId(choiceIds: number[]) {
    return choiceIds[choiceIds.length - 1];
  }

  private getOptionById(id: number): MultiScaleOption {
    return this.options.filter(option => option.id === id)[0] || new MultiScaleOption(-1, -1);
  }

  private setScaleChoiceStatus(option: MultiScaleOption) {
    this.choiceIds.forEach(optionId => {
      let curOption = this.getOptionById(optionId);
      let parent = this.getOptionById(curOption.parentId);
      this.scales.push(this.getChildren(parent));
    });
    if (this.hasChildren(option)) {
      this.scales.push(this.getChildren(option));
    }
  }

  private setOptionLinkName(choiceOption: MultiScaleOption) {
    let linkNames = [];
    this.getLinkNames(choiceOption, linkNames);
    choiceOption.linkName = linkNames.join(' > ');
  }

  private getLinkNames(option: MultiScaleOption, linkNames: string[]) {
    linkNames.unshift(option.name);
    if (option.parentId !== -1) {
      this.getLinkNames(this.getOptionById(option.parentId), linkNames);
    }
  }
}
